export const SAME_ORIGIN_AUTH_TOKEN = "__lytebulb_same_origin_auth__";

export function isSameOriginAuthToken(value) {
  return String(value || "").trim() === SAME_ORIGIN_AUTH_TOKEN;
}

export function devProxyAuthEnabled() {
  return Boolean(import.meta.env?.DEV)
    && !Boolean(import.meta.env?.VITEST)
    && typeof window !== "undefined";
}

export function defaultClientAuthToken() {
  return devProxyAuthEnabled() ? SAME_ORIGIN_AUTH_TOKEN : "";
}
